/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsMiniArrowRightCircle = ({ className }) => {
  return (
    <svg
      className={`heroicons-mini-arrow-right-circle ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        clipRule="evenodd"
        d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM6.75 9.25C6.33579 9.25 6 9.58579 6 10C6 10.4142 6.33579 10.75 6.75 10.75H11.3401L9.23966 12.7004C8.93613 12.9823 8.91855 13.4568 9.20041 13.7603C9.48226 14.0639 9.95681 14.0814 10.2603 13.7996L13.7603 10.5496C13.9132 10.4077 14 10.2086 14 10C14 9.79145 13.9132 9.59231 13.7603 9.4504L10.2603 6.2004C9.95681 5.91855 9.48226 5.93613 9.2004 6.23966C8.91855 6.54319 8.93613 7.01774 9.23966 7.2996L11.3401 9.25H6.75Z"
        fill="#7041F1"
        fillRule="evenodd"
      />
    </svg>
  );
};
